import {where} from "firebase/firestore";
import {contarSumaWhere} from "../../Servicios/BD/Contadores/contarSumaWhere";

export const obtenerTotalBonos = async (idUsuario) => {


    let w = [where('idUsuario', '==', idUsuario), where('estado', 'in', ['Aceptado', 'Validando']), where('tipo', '==', 'Bono')];
    let dox = await contarSumaWhere({coleccion: 'movimientos', wheres: w, propiedad: 'valor'})

    if (dox.res) {
        return dox.data
    } else {
        return 0
    }


}